/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

// Function to update explore models when board model is ready
function onWidgetModelReady(self, content) {
	if (self.layoutModel) {
		// We're only interested in events for the current card.
		const cardModel = self.layoutModel.findModel(self.displayedCard);
		if (cardModel) {
			const contentId = content.getId();
			const widgetModel = cardModel.findModel(contentId);
			if (widgetModel) {
				const state = content.getFeature('state');
				if (state.getStatus() !== 'rendering') {
					// Only select the widget in a non-compare card.
					if (!cardModel.isCompareEnabled) {
						self.selectWidget(contentId);
					}
					self._updateActiveDataSourceId(self.displayedCard);
					self.toolbar.fetchWidgetActions();
					widgetModel.forceRender_HACK();
				}
			}
		}
	}
}

export default {
	onWidgetModelReady
};



// WEBPACK FOOTER //
// ./src/js/layout/explorecontainer/ExploreVMUtils.js